import {
    Grid,
    Box,
    Typography,
    Divider
} from '@mui/material';
import Modal from '@mui/material/Modal';
import { IComandaEtapaReunioes, IEtapa } from '../../../commons/types/crm';
import { useTranslation } from '../../../commons/useTranslasion';
import { esES, ptBR } from '@mui/material/locale';
import { useDateFormatters } from '../../../utils/useDateFormatters';

export interface IDetalhes {
    open: boolean;
    handleClose: () => void;
    selectedReuniao?: IComandaEtapaReunioes;
    etapa: IEtapa;
}

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 800,
    bgcolor: 'background.paper',
    border: '1px solid #000',
    borderRadius: '20px',
    boxShadow: 24,
    p: 4,
};

const DetalhesReuniaoModal: React.FC<IDetalhes> = ({
    open,
    handleClose,
    selectedReuniao
}) => {
    const { translate, language } = useTranslation();
    const { formatarData, formatarDataHora } = useDateFormatters();
    const lang = language ?? "pt-br";
    let locale = ptBR;
    switch (lang.slice(0, 2)) {
      case "es":
        locale = esES
        break;
    }
    

    if (!selectedReuniao) {
        return null;
    }

    const consultor = selectedReuniao?.consultorResponsavel?.nome || translate('nomeDoConsultor');
    const status = selectedReuniao?.status || translate('statusDaReuniao');
    const data = formatarData(selectedReuniao.dtPrevista);
    const dataInicio = selectedReuniao.dtRealizadaInicio
        ? formatarDataHora(selectedReuniao.dtRealizadaInicio)
        : translate('naoIniciada');
    const dataFim = selectedReuniao.dtRealizadaFim
        ? formatarDataHora(selectedReuniao.dtRealizadaFim)
        : translate('naoFinalizada');

    return (
        <>
            <Modal open={open} onClose={handleClose} sx={{ borderRadius: '20px' }}>
                <Box sx={style}>
                    <Typography id="modal-modal-title" variant="h6" component="h2" gutterBottom>
                        {translate('detalhesDaReuniao')}
                    </Typography>

                    <Divider />

                    <Grid container spacing={2} sx={{ marginTop: '10px' }}>
                        <Grid item xs={6}>
                            <Typography>
                                <strong>{translate('consultor')}:</strong> {consultor}
                            </Typography>
                        </Grid>
                        <Grid item xs={6}>
                            <Typography>
                                <strong>{translate('status')}:</strong> {status.replace('_', ' ')}
                            </Typography>
                        </Grid>
                        <Grid item xs={6}>
                            <Typography>
                                <strong>{translate('dataInicio')}:</strong> {dataInicio}
                            </Typography>
                        </Grid>
                        <Grid item xs={6}>
                            <Typography>
                                <strong>{translate('dataFim')}:</strong> {dataFim}
                            </Typography>
                        </Grid>
                    </Grid>
                </Box>
            </Modal>
        </>
    );
};

export default DetalhesReuniaoModal;